import { S as Swiper } from './swiper-core-DtIdGk2i.js';

class QuickShopMediaSwiper extends HTMLElement {
  swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      slidesPerView: 3.2,
      spaceBetween: 1,
      breakpoints: {
        768: {
          slidesPerView: 5.2,
        },
      },
    });
  }
}

customElements.define('quick-shop-media-swiper', QuickShopMediaSwiper);
